export default __webpack_public_path__ + "static/media/8.8de6cd9c.svg";